export default __webpack_public_path__ + "static/media/reservationSite.47232e3f.png";